'use client';

import { Button } from '@/components/button';
import MagazineTrendCard from '@/components/magazineTrendCard/MagazineTrendCard';
import classes from '@/components/magazineTrendCards/MagazineTrendCards.module.scss';
import { linkToString } from '@/helper/urls';
import { resolveStory } from '@/helper/utils';
import type { PageMagArticleStoryblok } from '@/types/component-types-sb';
import type { ISbStoryData } from '@storyblok/react/rsc';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MagazineTrendCards: React.FC<{
  trendArticles: (string | ISbStoryData<PageMagArticleStoryblok>)[] | null;
}> = ({ trendArticles }) => {
  const [showPopular, setShowPopular] = useState(false);
  const { t } = useTranslation();

  if (!trendArticles || trendArticles.length === 0) return;

  return (
    <div className={classes.MagazineTrendCards}>
      {trendArticles.map((articleUnresolved, index) => {
        const article = resolveStory(articleUnresolved);
        return (
          <MagazineTrendCard
            key={article?.uuid}
            title={article?.content.headline}
            image={article?.content.image}
            date={article?.first_published_at || article?.created_at || ''}
            link={linkToString(article?.full_slug)}
            className={classNames({
              [classes.hiddenMobile!]: index >= 3 && !showPopular,
            })}
          />
        );
      })}

      {/* Shown only on mobile screen */}
      {!showPopular && (
        <Button
          className={classes.loadMoreButton}
          variant="ctaWhite"
          onClick={() => {
            setShowPopular(true);
          }}
        >
          {t('Weitere Trend-Themen anzeigen')}
        </Button>
      )}
    </div>
  );
};
export default MagazineTrendCards;
